/* hb-matelas-min5.js
   Règle "minimum 5 matelas épais (10/15 cm)" — vente par palette.
   Additif & défensif : ne modifie aucun code existant. En cas d'erreur ou de
   sélecteur non trouvé, il NE BLOQUE RIEN (échec sûr = pas de blocage abusif).
   Matche par ID de variante (les 9 variantes épaisses déplacées en profil palette). */
(function () {
  try {
    var THICK = [
      53236194214154, 53239303536906, 53270125904138, // Matelas anti-escarre 10/15/120x15
      53247156814090, 53247156846858, 53276064284938, // Maison & appartement 10/15/120x15
      53247156945162, 53247156977930, 53276064317706  // Mobile home 10/15/120x15
    ];
    var MIN = 5;
    var MSG_ID = 'hb-matelas-min5-msg';

    function setButtons(block) {
      var sel = '[name="checkout"], button[name="checkout"], .cart__checkout-button, #checkout, #Checkout, [data-cart-checkout], .cart-drawer__checkout';
      var btns = document.querySelectorAll(sel);
      for (var i = 0; i < btns.length; i++) {
        var b = btns[i];
        if (block) { b.setAttribute('disabled', 'disabled'); b.setAttribute('aria-disabled', 'true'); b.style.opacity = '0.45'; b.style.cursor = 'not-allowed'; b.style.pointerEvents = 'none'; }
        else { b.removeAttribute('disabled'); b.removeAttribute('aria-disabled'); b.style.opacity = ''; b.style.cursor = ''; b.style.pointerEvents = ''; }
      }
    }

    function setMessage(block, qty) {
      var existing = document.getElementById(MSG_ID);
      if (block) {
        if (!existing) {
          existing = document.createElement('div');
          existing.id = MSG_ID;
          existing.style.cssText = 'margin:12px 0;padding:12px 16px;border-radius:10px;background:#fff1e8;border:1px solid #e07b39;color:#8a4a22;font-size:14px;font-weight:600;line-height:1.4;';
          var anchor = document.querySelector('.cart__footer, .cart-drawer__footer, .drawer__footer, cart-drawer .drawer__inner, #main-cart-footer') ||
            (document.querySelector('[name="checkout"]') && document.querySelector('[name="checkout"]').parentNode);
          if (anchor) { anchor.insertBefore(existing, anchor.firstChild); } else { return; }
        }
        existing.textContent = '🛏️ Les matelas épais (10/15 cm) se commandent par palette : minimum ' + MIN + '. Vous en avez ' + qty + ' — ajoutez-en ' + (MIN - qty) + ' de plus pour valider la commande.';
      } else if (existing) {
        existing.parentNode && existing.parentNode.removeChild(existing);
      }
    }

    function check() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          try {
            var qty = 0, items = (cart && cart.items) || [];
            for (var i = 0; i < items.length; i++) {
              if (THICK.indexOf(items[i].variant_id) !== -1) { qty += items[i].quantity; }
            }
            var block = qty > 0 && qty < MIN;
            setButtons(block);
            setMessage(block, qty);
          } catch (e) { /* échec sûr : on ne bloque pas */ setButtons(false); }
        })
        .catch(function () { /* échec sûr */ setButtons(false); });
    }

    // ---- Page produit : masquer le buy-now si variante épaisse (force le passage par le panier) ----
    function productBuyNow() {
      try {
        var idInput = document.querySelector('[data-hb-variant-id]');
        var buynow = document.querySelector('.hb-product__buynow');
        if (!idInput || !buynow) { return; } // pas une page produit concernée
        function update() {
          try {
            var isThick = THICK.indexOf(parseInt(idInput.value, 10)) !== -1;
            buynow.style.display = isThick ? 'none' : '';
          } catch (e) { /* échec sûr : on laisse le buy-now visible */ }
        }
        update();
        document.addEventListener('click', function () { setTimeout(update, 250); }, true);
        document.addEventListener('change', function () { setTimeout(update, 250); }, true);
      } catch (e) { /* no-op */ }
    }

    function init() { check(); productBuyNow(); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (ev) { document.addEventListener(ev, check); });
    // Re-check après les interactions panier (ajout, +/-, ouverture tiroir)
    document.addEventListener('click', function () { setTimeout(check, 700); }, true);
  } catch (e) { /* no-op */ }
})();
